import { isNumber, isNil } from '@/utils/checks'
export const generateReviewsBadgeText = ({
  hasReviews,
  isVerified,
  shouldDefaultRegionalize,
  overrideVerified,
  count
}: {
  hasReviews: boolean
  isVerified: boolean
  shouldDefaultRegionalize: boolean
  overrideVerified: boolean
  count: number | null
}): string => {
  if (hasReviews && isNumber(count) && !isNil(count) && !isNaN(count)) {
    return `(${count})`
  }

  if (isVerified || overrideVerified) {
    return shouldDefaultRegionalize ? 'Verified Centre' : 'Verified Center'
  }

  return 'No Reviews'
}
